import React, { useState } from 'react';
import {Button, Form, Modal, ConfigProvider, notification, Col, Input} from 'antd';
import Axios from "../../config/axiosConfig/axios";
import {Api} from "../../config/apiList/api";




const DeactiveAmlakModal = ({ open, onCreate, onCancel , id, isActive, setOpen, setAmlakList, pageNumber}) => {


    return (
        <ConfigProvider direction="rtl">
            <Modal
                style={{fontFamily: "iranSansBold"}}
                bodyStyle={{height: 100}}
                // style={{fontFamily: "iranSansBold"}}
                width={400}
                open={open}
                title={isActive === true? "آیا از غیر فعال کردن املاک مطمئن هستید": "آیا از فعال کردن املاک مطمئن هستید؟"}
                okText="تایید"
                cancelText="انصراف"
                onCancel={onCancel}
                closable={false}
                onOk={async () => {
                    await Axios.patch(`${Api}change-activitions-amlak-panel/${id}`, {}).then((data) =>{
                        if(data.statusCode === 200 || data.statusCode === 201){
                            notification.open({
                                message: "موفقیت",
                                description: "درخواست با موفقیت انجام شد!",
                                style: {
                                    background: "#43a047",
                                    color: "white",
                                    fontFamily: "IRANSansMobileFaNum",
                                    borderRadius: "5px",
                                }
                            })


                        }

                        else{
                            notification.open({
                                message: "خطا!",
                                description: data.data.message,
                                style: {
                                    background: "#b00000",
                                    color: "white",
                                    fontFamily: "IRANSansMobileFaNum",
                                    borderRadius: "5px",
                                }
                            })


                        }
                    }).catch((err) => {
                        notification.open({
                            message: "خطا!",
                            description: "در برقراری ارتباط با سرور مشکل پیش آمده!",
                            style: {
                                background: "#b00000",
                                color: "white",
                                fontFamily: "IRANSansMobileFaNum",
                                borderRadius: "5px",
                            }
                        })
                    })

                    await Axios.get(`${Api}amlak-list-panel?page=${pageNumber}`
                    )
                        .then((data) => {
                            if (data.statusCode === 200 || data.statusCode === 201) {
                                // console.log(data.data.data);
                                setAmlakList(data.data.data);


                            }

                        })
                        .catch((error) => {
                        });

                    await setOpen(false);
                }}
            >
            </Modal>
        </ConfigProvider>
    );
};

const DeactiveAmlak = (props) => {
    const [open, setOpen] = useState(false);

    const onButtonCLick =() =>{
        if(open === true){
            setOpen(false)
        }
        else{
            setOpen(true)
        }
    }

    const button = (isActive) =>{
        if(isActive === true){
            return <Button style={{ borderRadius: "20px", backgroundColor: "#00ff04"}} onClick={onButtonCLick} type={"primary"}>غیر فعال کردن</Button>
        }

        return <Button style={{ borderRadius: "20px", backgroundColor: "#ff0000"}} onClick={onButtonCLick} type={"primary"}>فعال کردن</Button>

    }

    const RedNotification = (text) => {
        notification.open({
            message: "اخطار",
            description: text,
            style: {
                background: "#F3585c",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }

    const onCreate = async () => {

    };
    return (
        <div>
            {/*<Button style={{ borderRadius: "20px", backgroundColor: "#00ff04"}} type={"primary"}>فعال کردن</Button>*/}

            {button(props.isActive)}

            <DeactiveAmlakModal
                setAmlakList={props.setAmlakList}
                pageNumber={props.pageNumber}
                setOpen={setOpen}
                id={props.id}
                isActive={props.isActive}
                open={open}
                onCreate={onCreate}
                onCancel={() => {
                    setOpen(false);
                }}


            />
        </div>
    );
};
export default DeactiveAmlak;